import React from 'react';
import { LinkProps, cn, twVariants } from '@kiiwi/ui';
import { Slot, Slottable } from '@radix-ui/react-slot';
import FontAwesomeIcon from '@kiiwi/ui/dist/FontawesomeIcon';

const linkStyles = twVariants({
  slots: {
    root: [
      'inline-flex items-center gap-1.5 text-body-1 font-normal text-[--kiiwi-indigo-400] transition-colors underline',
      'hover:no-underline active:no-underline',
      'active:text-[--kiiwi-indigo-400]',
      'visited:text-[--kiiwi-text-picker-indigo]',
    ],
    externalIcon: ['h-4 w-4'],
  },
  variants: {
    disabled: {
      true: {
        root:
          'pointer-events-none text-[--kiiwi-background-picker-medium-indigo] visited:text-[--kiiwi-background-picker-medium-indigo] active:text-[--kiiwi-background-picker-medium-indigo]',
      },
    },
  },
});

// As of kiiwi-ui@1.0.0, the asProps property of the Link component cannot be used (causes runtime errors) + the colors and underline differ from DS - Kiiwi figma.
// TODO: Remove this component when kiiwi-ui component is fixed and compliant with figma.
const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  (
    {
      className,
      asChild = false,
      external = false,
      disabled = false,
      children,
      ...props
    },
    ref,
  ) => {
    const Comp = asChild ? Slot : 'a';
    const { root, externalIcon } = linkStyles({ disabled });
    return (
      <Comp ref={ref} className={cn(root(), className)} {...props}>
        <Slottable>{children}</Slottable>
        {external && (
          <FontAwesomeIcon
            name="arrow-up-right:regular"
            className={externalIcon()}
          />
        )}
      </Comp>
    );
  },
);

export default Link;
